import { render, staticRenderFns } from "./EditDialog.vue?vue&type=template&id=0a53211e&scoped=true&"
import script from "./EditDialog.vue?vue&type=script&lang=ts&"
export * from "./EditDialog.vue?vue&type=script&lang=ts&"
import style0 from "./EditDialog.vue?vue&type=style&index=0&id=0a53211e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a53211e",
  null
  
)

export default component.exports